var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dashboard"},[_c('Navbar'),_c('Carousel'),_c('About',{staticClass:"about"}),_c('VisionMission'),_c('Products'),_c('Highlights'),_c('Footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }